/* eslint-disable @tanstack/query/exhaustive-deps --
   Keep the data API out of query keys. It is only used inside `queryFn`, and
   PlatformDataApi contains a circular Auth0 client that breaks key serialization.
   Real cache inputs are still included in each key.  */
import { queryOptions } from "@tanstack/react-query";

import { ISharedDataApi } from "../types";

export const getFlexStationEventLogOptions = (
  dataApi: ISharedDataApi | null,
  substationUid?: string,
  flexstationUid?: string,
  // Required by the platform (network-scoped) API; ignored by PropAI's /v1 endpoint,
  // but still keyed so PropAI and platform queries never collide in the cache.
  networkUid?: string
) =>
  queryOptions({
    queryKey: [
      "substations",
      substationUid,
      "flexstations",
      flexstationUid,
      "event-log",
      networkUid,
    ],
    queryFn: () => dataApi?.getFlexStationEventLog(substationUid, flexstationUid, networkUid),
    enabled: !!dataApi && !!substationUid && !!flexstationUid,
    staleTime: 5 * 60 * 1000,
  });
